import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      // 1. Check if we just arrived from GitHub via the Session Bridge
      const urlParams = new URLSearchParams(window.location.search);
      const sessionToken = urlParams.get('session_token');

      if (sessionToken) {
        console.log('[Auth] Session Bridge token detected. Persisting and exchanging...');
        localStorage.setItem('session_token', sessionToken);
        try {
          await authApi.setSession(sessionToken);
          console.log('[Auth] Session cookie request sent.');
        } catch (err) {
          console.error('[Auth] Session Bridge exchange failed (cookie only), continuing with Bearer:', err);
        }
        // Clean up URL to prevent replay/confusion
        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      }

      console.log('[Auth] Checking current session status...');
      const data = await authApi.getMe();
      if (data.authenticated) {
        console.log('[Auth] User verified:', data.username);
        setUser(data);
        setIsAuthenticated(true);
      } else {
        console.log('[Auth] No active session found.');
        setUser(null);
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('[Auth] Identity check failed:', error);
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const loginWithGithub = () => {
    authApi.login();
  };

  const logout = () => {
    localStorage.removeItem('session_token');
    authApi.logout();
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        loading,
        loginWithGithub,
        logout,
        checkAuth,
        requestAccess: authApi.requestAccess
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
